{
    const button = document.querySelector('.rollover-page__footer button');
    button.addEventListener('click', function () {
        this.classList.toggle('active');

        const tableItems = document.querySelectorAll(
            "div.rollover-page__wrapper-desktop table .block-wrapper"
        );

        [...tableItems].forEach((item, id) => {
            if (id >= 4) {
                item.classList.contains('hidden')
                ? item.classList.remove('hidden')
                : item.classList.add('hidden');
            }
        });

        this.textContent = this.classList.contains('active')
            ? m.trans.get('View less')
            : m.trans.get('View more');
    });
}
